import { TextAreaInput } from '@american-autonomy/ag-ui';

import { NOTES_INPUT_ROWS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const NotesInput: FunctionComponent<Props> = ({
    className = '',
    isDisabled,
    isEditable,
    isRequired,
    maxCharacters,
    name,
    onBlur,
    onChange,
    onInit,
    placeholder,
    testId = TEST_ID,
    value
}) => (
    <TextAreaInput
        className={`${className} ${styles.notesInput}`}
        isDisabled={isDisabled}
        isEditable={isEditable}
        isRequired={isRequired}
        maxCharacters={maxCharacters}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onInit={onInit}
        placeholder={placeholder}
        rows={NOTES_INPUT_ROWS}
        testId={testId}
        value={value}
    />
);

export default NotesInput;
